import React from 'react';

import { Box, styled } from '@mui/material';
import { versionInfo } from "../../utils";


const Version= styled(Box)(
    ({ theme }) => `
          color: #ccc;
          padding: ${theme.spacing(0.4, 1)};
          border-radius: ${theme.general.borderRadiusSm};
          text-align: center;
          display: inline-block;
          line-height: 1;
          font-size: ${theme.typography.pxToRem(16)};
          background-color: transparent !important;
  `
  );

const VersionBadge = () => {
  return (
    <Version>Version - {versionInfo.Version}</Version>
  )
}

export default VersionBadge